import Immutable from 'immutable';
import StaticLookup from '../../data/staticlookup';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LOOKUP = StaticLookup(Immutable.List([]));


const noopSet = () => {};
const noopGet = () => {return EMPTY_MAP;};
const getFalse = () => {return false;};
const getEmptyLookup = () =>  {return EMPTY_LOOKUP;};

export default function Binder(methods, bindTo) {
	if (!(this instanceof Binder)) {
		return new Binder(methods, bindTo);
	}

	let getData = (methods.getData || noopGet).bind(bindTo || this);
	let setData = (methods.setData || noopSet).bind(bindTo || this);
	let getLookup = (methods.getLookup || getEmptyLookup).bind(bindTo || this);
	let trigger = (methods.handleEvent || noopSet).bind(bindTo || this);
	let getModel = (methods.getModel || noopSet).bind(bindTo || this);
	let setModel = (methods.setModel || noopSet).bind(bindTo || this);

	const errorPath = methods.errorPath;
	const readOnlyPath = methods.readOnlyPath;

	this.trigger = function(eventType, params) {
		trigger(eventType, params);
	}

	this.getLookup = function(name, fixedParams) {
		return getLookup(name, fixedParams);
	};

	this.getData = function() {
		return getData();
	};

	this.getModel = function() {
		return getModel();
	};

	this.setModel = function(model) {
		setModel(model);
	};

	this.getProperty = function(path) {
		if (Array.isArray(path)) {
			return getData().getIn(path);
		} else {
			return getData().get(path);
		}
	};

	this.getErrorPath = function() {
		return errorPath;
	};

	this.getReadOnlyPath = function() {
		return readOnlyPath;
	}

	this.setData = function(data) {
		setData(data);
	};

}
